import { useEffect } from 'react';
import { useDispatch, useSelector, batch } from 'react-redux';
import { eventBus } from '@atc/cai-event-bus';
import { WALLET_UPDATE_PAYMENTS_INFO_COMPLETED, debugWallet } from 'wallet-manager';
import { getConsumerMetadata } from '@atc/consumer-metadata';
import { getWalletPixallMetadata, sendClick } from 'reaxl-analytics';
import { myWalletInputChange } from 'reaxl-analytics-handlers';
function useUpdatePaymentsInfo(_ref) {
  let {
    paymentsDuck
  } = _ref;
  const dispatch = useDispatch();
  const walletId = useSelector(paymentsDuck?.selectors?.getWalletId);
  const paymentsInfo = useSelector(paymentsDuck?.selectors?.getPaymentsInfo);
  async function sendWalletInputChangeEvent(_ref2) {
    let {
      updatedPayload,
      userInputData = {}
    } = _ref2;
    const {
      walletData,
      userModified,
      targetValue,
      extraData,
      inputName
    } = userInputData;

    // TODO: Do we still need to call this?
    const consumerMetadata = await getConsumerMetadata();
    consumerMetadata.walletId = walletId;
    const pixallWalletData = {
      ...paymentsInfo,
      ...updatedPayload
    };
    const pixallTradeinData = walletData === 'tradeIn' ? updatedPayload?.tradeIn : paymentsInfo?.tradeIn;
    const pixallMetadata = {
      ...pixallWalletData,
      tradeIn: {
        ...pixallTradeinData
      }
    };
    const {
      dealMetadata,
      tradeinMetadata
    } = getWalletPixallMetadata(pixallMetadata, userModified);
    const analyticsPayload = {
      inputName,
      dealMetadata,
      consumerMetadata,
      tradeinMetadata,
      extraData,
      targetValue,
      paymentsDuck
    };
    debugWallet('myWalletInputChange: ', analyticsPayload);
    sendClick(myWalletInputChange, null, analyticsPayload);
  }
  function handleUpdatePaymentsInfo() {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      updated,
      updatedPayload,
      hasUpdatedBudget,
      hasMonthlyBudget,
      userInputData,
      success,
      updatedPaymentsInfo
    } = data;
    debugWallet('update payments info completed: ', data);

    // if user updated any fields in wallet modal, send myWalletInputChange event
    if (userInputData?.inputName) {
      sendWalletInputChangeEvent({
        updatedPayload,
        userInputData
      });
    }
    batch(() => {
      // if it fails to update payments info, display error
      dispatch(paymentsDuck.creators.updateMyWallet({
        displayWalletErrorMessage: !updated || !success
      }));
      const interactionsToUpdate = {
        isFetchingBudgetData: false,
        hasRequestedTaxesFees: updatedPaymentsInfo?.interactions?.hasRequestedTaxesFees
      };
      if (hasUpdatedBudget) {
        interactionsToUpdate.hasUpdatedBudget = true;
        interactionsToUpdate.showPaymentInFilter = true;
      }
      if (hasMonthlyBudget) {
        interactionsToUpdate.fromNds = false;
        interactionsToUpdate.isInitialBudget = false;
      }
      dispatch(paymentsDuck.creators.updateMyWalletInteractions(interactionsToUpdate));
    });
  }
  useEffect(() => {
    eventBus.on(WALLET_UPDATE_PAYMENTS_INFO_COMPLETED, handleUpdatePaymentsInfo);
    return () => {
      eventBus.off(WALLET_UPDATE_PAYMENTS_INFO_COMPLETED, handleUpdatePaymentsInfo);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
export { useUpdatePaymentsInfo as default };
